module.exports = __webpack_public_path__ + "Icono_Toracica-Ngr_126px.png";